import { t } from "@/i18n-js/instance";
import { useAttachmentMetadata } from "@circle-react-shared/BuilderUI/Media/AttachmentContext";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";

export interface BulletProp {
  emoji?: string;
  placeholder?: string;
  signed_id?: string;
}

export interface BulletProps {
  bullet: BulletProp;
  styles?: Record<string, StyleValue>;
}

export const Bullet = ({ bullet, styles = {} }: BulletProps) => {
  const { emoji = "", signed_id = "" } = bullet;
  const attachmentMetadata = useAttachmentMetadata(signed_id);

  if (emoji) {
    return <span>{emoji}</span>;
  }

  const { url } = attachmentMetadata ?? {};
  const imageUrl = bullet.placeholder || url;

  if (imageUrl) {
    return (
      <img
        style={parseStyles({ styles })}
        className="wb-block wb-rounded-full"
        loading="lazy"
        src={imageUrl}
        alt=""
        aria-label={t("icon")}
      />
    );
  }

  /* TODO: Handle shapes */
  return null;
};
